import Child from '@/models/enrollment/child';
import ChildIdentity from '@/models/enrollment/childIdentity';
import CustodyArragement from '@/models/enrollment/custodyArragement';
import PhysicalRequirement from '@/models/enrollment/physicalRequirement';
import SchoolArrangement from '@/models/enrollment/schoolArrangement';
import SleepArragement from '@/models/enrollment/sleepArragement';

export default {
  setInvitationLink(state: any, invitationLink: string) {
    state.invitationLink = invitationLink;
  },
  setNumberInQueue(state: any, number: number) {
    state.numberInQueue = number;
  },
  clear(state: any) {
    state.invitationLink = [];
    state.numberInQueue = null;
    state.completedForms = 0;
    state.languages = [];
    state.childInfo = null;
    state.children = new Array<Child>();
    state.vaccines = [];
    state.initialHealthInfo = null;
    state.allergens = [];
    state.skinProducts = [];
  },
  updateLanguages(state: any, languages: []) {
    state.languages = languages;
  },
  setChildren(state: any, children: Array<Child>) {
    state.children = [ ...children ];
  },
  updateChild(state: any, updatedChild: Child) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(updatedChild.id);
    
    state.children.splice(indexOfUpdatedChild, 1, updatedChild);
  },
  addChildInfo(state: any, childIdentity: ChildIdentity) {
    const newChild = new Child();
    
    newChild.id = childIdentity.id;
    newChild.age = childIdentity.age;
    newChild.ageGroupId = childIdentity.ageGroupId;
    newChild.childAddress = childIdentity.childAddress;
    newChild.dateOfBirth = childIdentity.dateOfBirth;
    newChild.firstName = childIdentity.firstName;
    newChild.lastName = childIdentity.lastName;
    newChild.prefferedName = childIdentity.prefferedName;
    newChild.childLanguages = childIdentity.childLanguages;
    newChild.enrollmentStepsCompleted = childIdentity.enrollmentStepsCompleted;
    state.children.push(newChild);
  },
  updateChildInfo(state: any, childIdentity: ChildIdentity) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childIdentity.id);
    const updatedChild = new Child();
    
    updatedChild.id = childIdentity.id;
    updatedChild.age = childIdentity.age;
    updatedChild.ageGroupId = childIdentity.ageGroupId;
    updatedChild.childAddress = childIdentity.childAddress;
    updatedChild.dateOfBirth = childIdentity.dateOfBirth;
    updatedChild.firstName = childIdentity.firstName;
    updatedChild.lastName = childIdentity.lastName;
    updatedChild.prefferedName = childIdentity.prefferedName;
    updatedChild.childLanguages = childIdentity.childLanguages;
    updatedChild.enrollmentStepsCompleted = childIdentity.enrollmentStepsCompleted;
    state.children.splice(indexOfUpdatedChild, 1, updatedChild);
  },
  updateSchoolArrangement(state: any, schoolArrangement: SchoolArrangement) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(schoolArrangement.childId);
    
    state.children[indexOfUpdatedChild].schoolArrangement = schoolArrangement;
  },
  updateCustodyArrangement(state: any, custodyArrangement: CustodyArragement) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(custodyArrangement.childId);

    state.children[indexOfUpdatedChild].custodyArrangement = custodyArrangement;
  },
  updateEmergencyContacts(state: any, { childId, emergencyContacts }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);

    state.children[indexOfUpdatedChild].emergencyContacts = emergencyContacts;
  },
  updatePickupPersons(state: any, { childId, pickupPersons }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);
    
    state.children[indexOfUpdatedChild].pickupPersons = pickupPersons;
  },
  updateVaccines(state: any, vaccines: []) {
    state.vaccines = vaccines;
  },
  updateChildrenVaccinationDates(state: any, { childId, childrenVaccinationDates }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);

    state.children[indexOfUpdatedChild].childrenVaccinationDates = childrenVaccinationDates;
  },
  setInitialHealthInfo(state: any, initialHealthInfo: any) {
    state.initialHealthInfo = initialHealthInfo;
  },
  updateHealthInfo(state: any, { childId, healthInfo }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);

    state.children[indexOfUpdatedChild].healthInfo = {
      diseases: healthInfo.diseases,
      medicalDevicesLocations: healthInfo.medicalDevicesLocations,
      supportsAvailableToTheChild: healthInfo.supportsAvailableToTheChild,
      chosenDiseases: healthInfo.chosenDiseases,
      requiresAdditionalSupport: healthInfo.requiresAdditionalSupport,
      otherMedicalConditions: healthInfo.otherMedicalConditions,
      medicalDevices: healthInfo.medicalDevices,
      stepsToReduceRiskOfMedicalCondition: healthInfo.stepsToReduceRiskOfMedicalCondition,
      signsAndSymptomsOfAllergicReaction: healthInfo.signsAndSymptomsOfAllergicReaction,
      procedureIfAllergicReaction: healthInfo.procedureIfAllergicReaction,
      procedureDuringEvacuation: healthInfo.procedureDuringEvacuation,
      procedureDuringFieldTrips: healthInfo.procedureDuringFieldTrips,
      additionalMedicaConditionInfo: healthInfo.additionalMedicaConditionInfo,
    }
  },
  updateChildAllergyInfo(state: any, { childId, allergyModel }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);
    
    state.children[indexOfUpdatedChild].allergens = allergyModel.allergens;
    state.children[indexOfUpdatedChild].childAllergyInfo = allergyModel.childAllergyInfo;
  },
  setSkinProducts(state: any, skinProducts: []) {
    state.skinProducts = skinProducts;
  },
  updateChildSkinProducts(state: any, { childId, skinProducts }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);
    
    state.children[indexOfUpdatedChild].skinProducts = skinProducts;
  },
  updateChildFeedingArrangement(state: any, { childId, feedingArrangement }: any) {
    const children = [...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);
    
    state.children[indexOfUpdatedChild].feedingArrangement = feedingArrangement;
  },
  updatePhysicalRequirements(state: any, data: PhysicalRequirement) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(data.childId);

    if (state.children[indexOfUpdatedChild]) {
      state.children[indexOfUpdatedChild].physicalRequirements = data;
    }
  },
  updateChildSleepArrangement(state: any, data: SleepArragement) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(data.childId);

    state.children[indexOfUpdatedChild].sleepArrangement = data;
  },
  updateAdditionalEmergencyInfo(state: any, { childId, additionalEmergencyInfo }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);
    
    state.children[indexOfUpdatedChild].additionalEmergencyInfo = additionalEmergencyInfo;
  },
  updateAdditionalInfo(state: any, { childId, additionalInfo }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);
    
    state.children[indexOfUpdatedChild].additionalInfo = additionalInfo;
  },
  SET_CURRENT_VIEWED_STEP(state: any, { childId, step }: any) {
    const children = [ ...state.children ];
    const indexOfUpdatedChild = children.map((user) => user.id).indexOf(childId);
    
    state.children[indexOfUpdatedChild].currentViewedStep = step;
  },
  removeChild(state: any, childId: string) {
    const child = state.children.find((child: any) => child.id === childId);
    const index = state.children.indexOf(child);
    
    state.children.splice(index, 1);
  }
}